import {useMemo} from 'react';
import {NodeType} from 'crqlar-react-common/dist/models/automation/automation';
import {attachmentSourceSteps, readAttachmentSourceNodeIds, teamMembersStepAbove} from '../../../config/teamEmail';
import type {NodeEditorV2Props} from '../types';

/**
 * What Send team email reads from the graph: the Team members step whose runs reach it, and the steps it can attach
 * files from. Shared by the editor (its summary) and its side panel (recipient and attachments).
 */
export default function useTeamEmailSteps({
    nodeId, nodeConfig, upstreamNodes = [], flowNodes = [], flowConnections = []
}: NodeEditorV2Props) {
    const inGraph = !!nodeId && flowNodes.some(node => node.id === nodeId);
    const teamStep = useMemo(() => inGraph
        ? teamMembersStepAbove(nodeId!, flowNodes, flowConnections)
        : upstreamNodes.find(node => node.type === NodeType.TEAM_MEMBERS),
    [inGraph, nodeId, flowNodes, flowConnections, upstreamNodes]);
    const attachmentSources = useMemo(() => attachmentSourceSteps(upstreamNodes, flowNodes, flowConnections, nodeId),
        [upstreamNodes, flowNodes, flowConnections, nodeId]);
    const attachmentIds = readAttachmentSourceNodeIds(nodeConfig);
    const missingAttachments = attachmentIds.some(id => !attachmentSources.some(node => node.id === id));

    return {teamStep, attachmentSources, attachmentIds, missingAttachments};
}
